import React, { memo } from "react";

interface Member {
  sys: { id: string };
  media_url: string;
  fields: {
    fullName: string;
    linkedinProfile: string;
    company: string;
    role: string;
  };
}

interface CollegioProps {
  collegio: Member[] | null;
  linkedin: string;
}

const Collegio: React.FC<CollegioProps> = ({ collegio, linkedin }) => {
  return (
    <>
      {collegio && (
        <>
          <h1 className="text-[#00a695] text-2xl font-bold px-24 mt-24">
            Collegio dei Revisori
          </h1>
          <div className="grid grid-cols-3 gap-8 pt-16">
            {collegio.map((member) => (
              <div key={member.sys.id} className="pb-12">
                <div className="thumb">
                  <a
                    href={member.fields.linkedinProfile}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={member.media_url}
                      alt={`${member.fields.fullName}'s Profile Picture`}
                      className="mb-8"
                    />
                    <img
                      src={linkedin}
                      alt="LinkedIn Icon"
                      className="linkedin"
                    />
                  </a>
                </div>
                <h2 className="text-2xl font-[500]">{member.fields.fullName}</h2>
                <p className="text-xl opacity-50 pb-1">
                  {member.fields.company}
                </p>
                <p className="text-[#00a694] italic leading-tight font-[500]">
                  {member.fields.role}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default memo(Collegio);
